import * as skylineApi from "../skylineApi"
import { bindData, byId, notyf } from "../utils"
import * as adminFeed from '../adminFeed'

const root = byId("devicesTab")
const devicesTab = root.content.cloneNode(true).firstElementChild
let deviceViewE

export default function index(app) {
	app.router.on('/devices/:id', (match) => {
		const device = skylineApi.getDevice(match.data.id)
		if (!device) {
			app.router.navigate('/devices')
			return
		}

		const contentE = devicesTab.getElementsByClassName("deviceTabContent")[0]
		while (contentE.firstChild) {
			contentE.removeChild(contentE.firstChild)
		}
		deviceViewE = byId("deviceView").content.cloneNode(true).firstElementChild

		deviceViewE.querySelector('.saveButton').addEventListener('click', () => {
			const input = byId("deviceNameInput")
			const frequencyInput = byId("deviceFrequencyInput")
			skylineApi.updateDevice(device.id, {
				name: input.value,
				frequency: frequencyInput.value
			}).then(() => {
				app.router.navigate('/devices')
			}).catch((error) => {
				notyf.error(error.message)
			})
		})

		deviceViewE.querySelector(".deleteButton").addEventListener("click", async () => {
			if (!confirm("Are you sure you want to delete this device?")) return

			try {
				await skylineApi.deleteDevice(device)
				app.router.navigate("/devices")
			} catch (error) {
				notyf.error(error.message)
			}
		})

		bindData(device, deviceViewE)

		contentE.appendChild(deviceViewE)
		app.setContent(devicesTab, () => {
			adminFeed.unregister('device', device.id, handleAdminFeed)
			const map = document.getElementById('mapid')
			map.style.marginTop = ''
			map.style.height = ''
		})

		adminFeed.register('device', device.id, handleAdminFeed)
		const map = document.getElementById('mapid')
		map.style.marginTop = '50vh'
		map.style.height = 'calc(50vh - 40px)'
	})
}

function handleAdminFeed(entry) {
	if (!entry.device) {
		console.error("Got an admin feed without a device", entry)
		return
	}

	if (!deviceViewE) return

	switch (entry.action) {
		case "UPDATE":
			bindData(entry.device, deviceViewE)
			break
		case "DELETE":
			app.router.navigate('/devices')
	}
}